<template>
    <div>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item >知识条目</el-breadcrumb-item>
            </el-breadcrumb>
        <el-input placeholder="输入 主题 / 内容 / 相似问题 搜索知识条目" v-model="inputVal" clearable @clear="initList" @change="searchList" class="search_box">
            <el-button slot="append" icon="el-icon-search" :loading="!searchFlag" @click="searchList"></el-button>
        </el-input>
        <div class="index_content">
            <div class="first_tree">
                <el-tree :data="cats" node-key="id" :default-expanded-keys="expands" :expand-on-click-node="false" :props="defaultProps" :highlight-current="true" @node-click="catClick">
                    <template slot-scope="{node,data}">
                        <div class="tooltip_wrap">
                            <el-tooltip :ref="node.id" popper-class="pop" effect="light"  placement="right-start" :content="node.label" :disabled="tipFlag">
                                <span @mouseenter="tipHover($event,node)">{{node.label}}</span>
                            </el-tooltip>
                        </div>
                    </template>
                </el-tree>
            </div>
            <div class="second_tree">
                <el-tree :data="showList" :props="defaultProps2" :highlight-current="true" @node-click="handleNodeClick"></el-tree>
            </div>
            <div class="flex5">
                <div v-if="detailUrl" style="height:calc(100% - 6px)">
                    <iframe id="template-iframe" ref="iframe" :src="detailUrl" ></iframe>
                </div>
                <div v-else class="tips">
                    <h2>使用帮助</h2>
                    <p>在您使用的过程中，可以随时掌握和学习产品使用说明，以便帮助您更好的了解产品。</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getKnowledge,getCats,searchKnowledge} from '../request/api'
    export default {
        name: "index",
        data(){
            return {
                inputVal:'',
                detailUrl:'',
                activeIndex:'1',
                list:[],
                showList:[],
                searchFlag:true,
                defaultProps2: {
                    children: 'data',
                    label: 'name'
                },
                cats:[],
                defaultProps: {
                    children: 'children',
                    label: 'catalogName'
                },
                expands:[1],
                activeData:[],
                searchResult:[],
                tipFlag:false
            }
        },
        mounted() {
            // this.getCats()
            this.getKnowledge()
        },
        methods:{
            tipHover(event,node){
                const ev = event.target
                const ev_height = ev.offsetHeight  //实际高度
                const content_height = this.$refs[node.id].$el.parentNode.clientHeight
                if (content_height >= ev_height) {
                    this.tipFlag = true
                } else {
                    this.tipFlag = false
                }
            },
            searchList(){
                if(this.searchFlag){
                    this.searchFlag=false
                    if(this.inputVal.trim()){
                        let data={}
                        data.name=this.inputVal.trim()
                        searchKnowledge(data).then(res=>{
                            this.searchResult=[]
                            this.showList=[]
                            if(res.data.status==0){
                                if(res.data.data && res.data.data.length){
                                    let a=res.data.data
                                    if(this.list.length){
                                        a.forEach(item=>{
                                            this.list.forEach(item2=>{
                                                if(item.id==item2.id){
                                                    this.searchResult.push(item2)
                                                }
                                            })
                                        })
                                    }
                                }
                                if(this.activeData.length && this.searchResult.length){
                                    this.activeData.forEach(item=>{
                                        this.searchResult.forEach(item2=>{
                                            if(item.id==item2.id){
                                                this.showList.push(item2)
                                            }
                                        })
                                    })
                                }
                            }else{
                                this.$message.error(res.data.msg)
                            }
                            this.searchFlag=true
                        }).catch(err=>{
                            this.searchFlag=true
                        })
                    }else{
                        this.showList=this.activeData
                        this.searchResult=[]
                        this.searchFlag=true
                    }
                }
            },
            findClass(){

            },
            clickNode(d){
            },
            getCats(){
                getCats().then(res=>{
                    console.log('getcats---',res)
                    if(res.data.code==200){
                        if(res.data.data && res.data.data.length){
                            this.cats=this.toTree(res.data.data,this.list)
                        }
                    }else{
                        this.$message.error(res.data.msg)
                    }
                })
            },
            getKnowledge(){
                this.list=[]
                 let email=this.$store.state.email
                getKnowledge(email).then(res=>{
                    console.log('getknowledge----',res)
                    if(res.data.status==0){
                        if(res.data.data){
                            this.list=res.data.data ||  []
                            if(this.list.length){
                               this.list.sort((a,b)=>{
                                   return b.createdAt - a.createdAt
                               })
                            }
                            this.showList=this.list
                            this.activeData=this.list
                            this.getCats()
                           // this.list=this.category(res.data.result.records,'parentCatalogName')
                        }
                    }else{
                        this.$message.error(res.data.msg)
                    }
                })
            },
            handleNodeClick(data){
                let detailUrl='https://channel-sandbox.xiaoshouyi.com/embeded/servicecloud/catalogknowledge/preview.html?id='+data.id+'&tenantId=2035196364441676'
                if(window.location.href.indexOf('lapp-sandbox')==-1){
                    detailUrl='https://channel-p05.xiaoshouyi.com/embeded/servicecloud/catalogknowledge/preview.html?id='+data.id+'&tenantId=2093248191861102'
                }
                window.open(detailUrl,'_blank')
                // this.detailUrl=dataUrl
                // this.$nextTick(function(){
                //     var a=document.getElementById("template-iframe")
                //     var topWin = document.getElementById("template-iframe").contentWindow;
                //     let ass=topWin.document.getElementsByTagName("a")
                //     if(ass.length){
                //         ass.forEach(item=>{
                //             item.target='_blank'
                //         })
                //     }
                //     topWin.document.getElementsByTagName("a").target = "_blank";
                // })
            },
            initList(){
                this.showList=this.activeData
                this.searchResult=[]
            },
            catClick(data){
                this.activeData=data['items'] || []
                this.showList=[]
                if(this.inputVal.trim()){
                    if(data.items.length && this.searchResult.length){
                        data.items.forEach(item=>{
                            this.searchResult.forEach(item2=>{
                                if(item.id==item2.id){
                                    this.showList.push(item2)
                                }
                            })
                        })
                    }else{
                        this.showList=[]
                    }
                }else{
                    this.showList=data['items'] || []
                }
            },
            toTree(data,list) {
                let result = []
                if (!Array.isArray(data)) {
                    return result
                }
                if (!data.length) {
                    return result;
                }
                let map = {};
                data.forEach(item=>{
                    item.items=[]
                    if(list.length){
                        list.forEach(item2=>{
                            if(item2.classify==item.id){
                                item.items.push(item2)
                                data.forEach(item3=>{
                                    if(item3.id==item.parentId){
                                        (item3['items'] || (item3['items'] = [])).push(item2);
                                        
                                    }
                                    if(item3.items && item3.items.length){
                                        item3['items'].sort((a,b)=>{
                                           return b.createdAt - a.createdAt
                                       })
                                    }
                                })
                            }
                        })
                    }
                    if(item.items.length){
                       item.items.sort((a,b)=>{
                           return b.createdAt - a.createdAt
                       })
                   }
                    map[item.id] = item;
                    let parent = map[item.parentId];
                    if (parent) {
                        (parent.children || (parent.children = [])).push(item);
                        if(parent.children.length){
                            parent.children.sort((a,b)=> {
                                return a.categoryOrder - b.categoryOrder
                            })
                        }
                    } else {
                        result.push(item);
                    }
                })
                let out=[]
                let obj={}
                obj.id=0
                obj.catalogName='全部'
                obj.categoryOrder=1
                obj.children=result
                obj.items=list
                out.push(obj)
                // return result;
                return out 
            }
        }
    }
</script>

<style>
    iframe{
        width:100%;
        height:100%;
        border:0;
    }
    .index_content{
        display: flex;
        height:100%;
        overflow: auto;
    }
    .flex5{
        flex:3;
        padding-left:20px;
    }
    .tips{
        margin-top: 30px;
        text-align: center;
        line-height: 50px;
    }
    .search_box{
        width:500px;
        position: absolute;
        top:68px;
        right:15px;
    }
    .search_box .el-input-group__append .el-button{
        margin:0;
    }
    .first_tree{
        flex:1;
        padding-top:10px;
        background: rgb(219 233 245);
    }
    .second_tree{
        flex:2;
        padding:10px 0;
        border-right:1px solid #e9e9e9;
    }
    .el-tree{
        background: transparent;
    }
    .el-tree-node__content{
        height:auto;
        padding:3px 0;
    }
    .el-tree-node__content:hover{
        /*background-color: #bdd2b8;*/
    }
    .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
        /*background-color: #03a9f42e;*/
    }
    .el-tree-node{
        white-space: pre-wrap;
    }
    /*.el-tree-node__label {*/
    /*    text-overflow: ellipsis;*/
    /*    overflow: hidden;*/
    /*    white-space: nowrap;*/
    /*    max-width: 170px;*/
    /*}*/
    .tooltip_wrap{
        /*height:17px;*/
        font-size:14px;
        display: inline-block;
        display: -webkit-box;
        -webkit-line-clamp:1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
    }
     .pop{
        background: rgb(219 233 245) !important;
        border: 0!important;
    }
    .el-tooltip__popper .popper__arrow::after{
        border-width:0 !important;
    }
    /*.tooltip_wrap span{*/
    /*    line-height:1.3;*/
    /*}*/
</style>